import * as React from "react"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import { useSelector } from "react-redux"
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Grid } from "@mui/material"
import { findCode, getRandomInt, detectBrowser, sanitizeFilename } from "@util/helper"
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined"
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined"
import { useMediaQuery, useTheme } from "@mui/material"
import WebService from "@util/webService"
import useSnackbar from "@hooks/useSnackbar"
import useIndicator from "@hooks/useIndicator"
import axios from "axios"
import { Fragment, useEffect, useState, useRef, forwardRef, useImperativeHandle } from "react"
import moment from "moment"
import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
import MyTableHead from "@components/MyTableHead"
import ConfirmDialog from "@components/ConfirmDialog"
import Grow from "@mui/material/Grow"
import Paper from "@mui/material/Paper"
import Box from "@mui/material/Box"
import useAlert from "@hooks/useAlert"
import LinearProgress from '@mui/material/LinearProgress';

const ScreenRecording = forwardRef((props, ref) => {
  const { onPick, onSubmit, lecture } = props
  const streamRef = useRef()
  const recorderRef = useRef()
  const normalStopRef = useRef(false)
  const chunksRef = useRef([])
  const { alert, renderAlert } = useAlert()

  const startRecording = async () => {
    const availBrowsers = ['Chrome', 'Edge', 'Opera', 'Safari']
    const browser = detectBrowser()
    console.log('browser.name ===> ', browser.name)
    const emsg = '브라우저 버전이 화면녹화를 지원하지 않습니다.'
    if (!availBrowsers.includes(browser.name)) {
      alert('현재화면 녹화를 지원하지 않는 브라우저 입니다. Chrome/Edge/Opera 브라우저를 사용하세요')
      return
    }

    if (browser.name === 'Chrome' && +browser.majorVersion < 94) {
      alert(emsg)
      return
    }
    if (browser.name === 'Edge' && +browser.majorVersion < 94) {
      alert(emsg)
      return
    }
    if (browser.name === 'Opera' && +browser.majorVersion < 80) {
      alert(emsg)
      return
    }

    if (recorderRef.current) {
      return
    }

    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({ preferCurrentTab: true })
      streamRef.current = stream
      const recorder = new MediaRecorder(stream);
      recorderRef.current = recorder

      recorder.ondataavailable = (event) => {
        chunksRef.current.push(event.data)
      };

      recorder.onstop = async (event) => {
        if (!normalStopRef.current) {
          alert('선발 및 동영상이 저장 되지 않았습니다.')
          return
        }

        setTimeout(async () => {
          const blob = new Blob(chunksRef.current, { type: 'video/webm' });
          console.log('blob when stopped', blob)

          if (blob.size === 0) {
            alert('동영상 사이즈가 0 이어서 업로드 할 수 없습니다.')
          }
          else {
            console.log('submit with blob onSubmit', onSubmit)
            await onSubmit(blob)
          }

          chunksRef.current = []
          streamRef.current = null
          recorderRef.current = null
        }, 200)

      };

      recorder.start();
      console.log('recorder started')
      onPick()
      return true
    } catch (error) {
      alert('화면을 녹화할 수 없습니다. 컴퓨터 설정을 통해 브라우저에 화면 녹화 권한을 주어야 합니다.')
      console.error('Error starting recording:', error);
      throw error
    }
  }


  const stopRecording = () => {
    const recorder = recorderRef.current
    const stream = streamRef.current

    if (recorder && recorder.state === "recording") {
      normalStopRef.current = true

      // 현재 버퍼에 쌓인 데이터를 강제로 배출 명령
      recorder.requestData()

      // 찰나(100ms)의 시간을 주고 실제 정지
      setTimeout(() => {
        if (recorder.state !== "inactive") {
          recorder.stop()
        }

        // 스트림 트랙 중지는 레코더가 멈춘 뒤에 하는 것이 가장 안전함
        if (stream) {
          stream.getTracks().forEach((track) => track.stop())
        }
      }, 150)
    } else {
      // 이미 레코딩 중이 아니더라도 스트림은 정리
      if (stream) {
        stream.getTracks().forEach((track) => track.stop())
      }
    }
  }

  const stopRecording_trash = () => {
    if (recorderRef.current) {
      normalStopRef.current = true
      recorderRef.current.stop()
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
    }
  }

  useImperativeHandle(ref, () => ({
    startRecording: startRecording,
    stopRecording: stopRecording,
  }))

  useEffect(() => {
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);


  return (
    <>
      {renderAlert()}
    </>
  )
})

const ManagerRegiPartPick = ({ record, open, onClose, reload }) => {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const [selCodeName, set_selCodeName] = React.useState("")
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))
  const [studentList, set_studentList] = React.useState([])
  const [pickList, _set_pickList] = useState([])
  const pickListRef = useRef(pickList)
  const [progress, set_progress] = useState(0)
  const set_pickList = (list) => {
    pickListRef.current = list
    _set_pickList(list)
  }
  const set_excList = (list) => {
    excListRef.current = list
    _set_excList(list)
  }
  const [excList, _set_excList] = useState([])
  const excListRef = useRef(excList)
  // redux
  // const codes = useSelector(state => state.codeReducer());
  const codes = useSelector((state) => state.codeReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)

  const dateFormat = "YYYY-MM-DD HH:mm:ss"
  const autoRecordingRef = useRef(true)
  const endRef = useRef(0)
  const screenRecordingRef = useRef()
  const [isSaving, set_isSaving] = useState(false)
  const fields = [
    { field: "id", placeholder: "", type: "text", value: -1, visible: false, canSrch: false, selList: [] },
    { field: "name", placeholder: "이름", type: "text", value: "", visible: true, canSrch: false, selList: [] },
    { field: "schoolId", placeholder: "학교명", type: "auto", value: "", visible: false, canSrch: true, selList: [] },
    { field: "grade", placeholder: "학년", type: "number", value: "", visible: true, canSrch: true, selList: [] },
    { field: "className", placeholder: "반", type: "text", value: "", visible: true, canSrch: true, selList: [] },
    { field: "classNum", placeholder: "번호", type: "number", value: "", visible: true, canSrch: false, selList: [] },
    { field: "remark", placeholder: "번호", type: "text", value: "", visible: false, canSrch: false, selList: [] },
    {
      field: "gdnPhone",
      placeholder: "보호자 전화 번호",
      type: "number",
      value: "",
      visible: true,
      canSrch: false,
      selList: [],
    },
  ]

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      return
    } else {
      set_pickList([])
      set_excList([])
      reload()
      onClose()
    }
  }

  const onLoad = async () => {
    openIndicator()
    // const regiList = await fetchRegis()

    const studentList = await fetchStudents()
    if (studentList) {
      studentList.forEach((row) => {
        row.statName = "신청 완료"
      })
      set_studentList(studentList)
    }

    const selCode = findCode(codes, "SA07", record.selCode)
    if (selCode) {
      set_selCodeName(selCode.name)
    }
    closeIndicator()
  }

  const fetchStudents = async () => {
    const url = "/regi/for/pick/student"
    const params = { lectureId: record.id }
    const resp = await WebService.get(url, params)

    if (resp.repCode === "ack") {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      return records
    } else {
      openSnackbar(resp.repMessage)
    }
  }


  const fetchPriorStudent = async (url) => {
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    return records
  }

  const classPickTrash = async () => {
    const url = `/student/regi/pick/${record.id}/S001`
    const records = await fetchPriorStudent(url)
    if (!records) {
      throw new Error('선발 불가')
    }
    const idSet = new Set(records.map(r => r.id))
    const intersection = studentList.filter(r => idSet.has(r.id))
    const remaining = studentList.filter(r => !idSet.has(r.id))
    remaining.sort(() => Math.random() - 0.5)
    console.log('remaining => ', remaining)
    if (intersection.length > record.recrNum) {
      alert('기수강한 학생이 수강신청한 학생보다 많아 전체 무작위로 선발합니다.', () => randomPick())
    }
    else {
      intersection.forEach((item, idx) => {
        item.name = item.name + '(기)'
      })
      const seqList = [...intersection, ...remaining]
      console.log('seqList', seqList)
      const picked = seqList.slice(0, +record.rcrNum)
      set_pickList(picked)
      const excluded = seqList.slice(+record.rcrNum)
      set_excList(excluded)
    }
  }

  const classPick = async () => {
    const url = `/student/regi/pick/${record.id}/S001`
    const records = await fetchPriorStudent(url)
    if (!records) {
      throw new Error('선발 불가')
    }
    const idSet = new Set(records.map(r => +r.id))
    const intersection = studentList.filter(r => idSet.has(+r.id))
    const remaining = studentList.filter(r => !idSet.has(+r.id))

    if (record.overCode === 'V002') { // 선착순
      console.log('기수강자우선 + 선착순')
      remaining.sort((a, b) => +a.regiId - +b.regiId)
    }
    else if (record.overCode === 'V003') { // 무작위 추첨.
      console.log('기수강자우선 + 무작위')
      remaining.sort(() => Math.random() - 0.5)
    }
    else {
      if (record.smstSelCode === 'S002') { // 선착순
        remaining.sort((a, b) => +a.regiId - +b.regiId)

      }
      else if (record.smstSelCode === 'S003') { // 무작위
        remaining.sort(() => Math.random() - 0.5)
      }
      else {
        alert('기수강자우선이지만 정원모집초과시 선발방법을 알 수 없습니다(2).')
        return
      }
    }

    console.log('remaining => ', remaining)
    if (intersection.length > record.recrNum) {
      // alert('기수강한 학생이 모집정원보다 많아 전체 무작위로 선발합니다.', () => randomPick())
      alert('기수강한 학생이 모집정원보다 많아 선발할 수 없습니다.')
      return
    }
    else {
      intersection.forEach((item, idx) => {
        item.name = item.name + '(기)'
      })
      const seqList = [...intersection, ...remaining]
      console.log('seqList', seqList)
      const picked = seqList.slice(0, +record.rcrNum)
      set_pickList(picked)
      const excluded = seqList.slice(+record.rcrNum)
      set_excList(excluded)
    }
  }

  const timePick = async () => {
    const url = `/student/regi/pick/${record.id}/S002`
    const seqList = await fetchPriorStudent(url)
    if (!seqList) {
      throw new Error('선발 불가')
    }

    const picked = seqList.slice(0, +record.rcrNum)
    set_pickList(picked)
    const excluded = seqList.slice(+record.rcrNum)
    set_excList(excluded)
  }


  const randomPick = () => {
    const seqList = []
    for (let i = 0; i < studentList.length; i++) {
      let student
      do {
        const idx = getRandomInt(studentList.length)
        student = studentList[idx]
      } while (student && seqList.some((o) => +o.id === +student.id))

      seqList.push(student)
    }

    const picked = seqList.slice(0, +record.rcrNum)
    set_pickList(picked)
    const excluded = seqList.slice(+record.rcrNum)
    set_excList(excluded)
  }


  const onPick = () => {
    if (studentList.length <= record.rcrNum) {
      const pickList = [...studentList]

      //
      if (pickList.length === 0) {
        onSubmit()
      }
      set_pickList(pickList)
    }
    else {
      if (record.selCode === 'S001') { // 기수강자 우선
        classPick()
      }
      else if (record.selCode === 'S002') { // 선착순
        timePick()
      }
      else if (record.selCode === 'S003') { // 무작위
        randomPick()
      }
      else {
        alert('알 수 없는 선발방식입니다.')
        throw new Error("학생선발 불발")
      }
    }
  }

  const endListener = () => {
    endRef.current = endRef.current + 1
    const progress = studentList.length === 0 ? 100 : Math.min(100 * endRef.current / studentList.length, 100);
    set_progress(progress)

    console.log('endRef.current =>', endRef.current)
    if (endRef.current >= studentList.length) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {

          if (autoRecordingRef.current) {
            openIndicator()
            setTimeout(() => {
              screenRecordingRef.current.stopRecording()
              closeIndicator()
            }, 1000)
          }
          else {
            onSubmit()
          }
        })
      })

    }
  }

  const autoPickAndSave = async () => {
    set_isSaving(true)
    autoRecordingRef.current = true
    try {
      await screenRecordingRef.current.startRecording()
    }
    catch (error) {
      alert(error)
      set_isSaving(false)
    }
  }

  const manualPickAndSave = () => {
    set_isSaving(true)
    autoRecordingRef.current = false
    onPick()
  }

  const onSubmit = async (blob) => {

    const url = `/lecture/pick/${schola.id}/${record.id}`

    const formData = new FormData()
    if (blob && blob.size > 0) {
      const file = new File([blob], `${record.title}.webm`)
      formData.append('files', file)
    }
    const data = {
      pickIdList: pickListRef.current.map(r => r.id),
      excIdList: excListRef.current.map(r => r.id)
    }

    const jsonData = JSON.stringify(data)

    formData.append("body", new Blob([jsonData], { type: "application/json" }))
    openIndicator()
    const resp = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    closeIndicator()

    if (resp.data.repCode === "ack") {
      alert("처리되었습니다.")
    } else {
      alert(resp.data.repMessage)
    }

  }

  useEffect(() => {
    if (open) {
      onLoad()
    }
  }, [open])

  useEffect(() => { }, [pickList])

  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose} maxWidth='lg' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            {record.title} 강좌 학생 선발
          </Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={6}>
              <Grid container spacing={1} sx={{ mb: 1 }}>
                <Grid item xs={6}>
                  <Typography variant={"h6"} align={"right"}>
                    {selCodeName} 선발방식
                  </Typography>
                </Grid>
                <Grid item xs={3} align={"right"}>

                  <ScreenRecording onPick={onPick} onSubmit={onSubmit} lecture={record} ref={screenRecordingRef} />
                  {/* <Button disabled={isSaving} variant={"contained"} onClick={autoPickAndSave}> */}
                  {/*   선발하기(자동녹화) */}
                  {/* </Button> */}
                  <ConfirmDialog
                    btn={
                      <Button disabled={isSaving} variant='contained'>
                        선발하기(자동녹화)
                      </Button>
                    }
                    title={"학생 선발"}
                    content={"현재 화면의 선발과정을 자동녹화하여 서버에 업로드 하고 다운로드합니다. 학생 선발을 진행하시겠습니까?"}
                    bc={"primary"}
                    perform={() => autoPickAndSave()}
                  />
                </Grid>
                <Grid item xs={3} align={'center'}>
                  <ConfirmDialog
                    btn={
                      <Button disabled={isSaving} variant='outlined'>
                        선발하기(녹화 없음)
                      </Button>
                    }
                    title={"학생 선발"}
                    content={"화면을 자동 녹화하지 않고 선발/저장하게 됩니다. 자동 녹화기능에 장애가 있을 때만 사용하세요."}
                    bc={"primary"}
                    perform={() => manualPickAndSave()}
                  />
                </Grid>
                <Grid item xs={12} >
                  <Box sx={{ width: '100%' }}>
                    <LinearProgress variant="determinate" value={progress} />
                  </Box>
                </Grid>
              </Grid>
              <MUITable>
                <MyTableHead>
                  <TableRow>
                    {fields.map((col, index) => {
                      if (col.visible) {
                        return (
                          <TableCell size='small' key={index} size='small'>
                            {col.placeholder}
                          </TableCell>
                        )
                      }
                    })}
                  </TableRow>
                </MyTableHead>
                <TableBody>
                  {studentList.map((row, index) => {
                    return (
                      <TableRow key={index}>
                        {fields.map((col, index) => {
                          if (col.visible) {
                            return <TableCell size='small'>{row[col.field]}</TableCell>
                          }
                        })}
                        <TableCell></TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </MUITable>
            </Grid>
            <Grid item xs={6} style={{ paddingLeft: 1 }}>
              <Grid container spacing={1} sx={{ mb: 1 }}>
                <Grid item xs={12}>
                  <Typography variant={"h6"} align={"center"}>
                    선발된 학생 목록
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Paper fullWidth elevation={5} sx={{ padding: 3, minHeight: "25vh", ml: 1 }}>
                    <Grid container>
                      {pickList.map((item, index) => (
                        <Grid xs={2.4} align={"center"}>
                          <Grow in={true} key={index} timeout={100 * (index + 1)} onEntered={endListener}>
                            <Box>{item.name}</Box>
                          </Grow>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant={"h6"} align={"center"}>
                    대기 학생 목록
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Paper fullWidth elevation={5} sx={{ padding: 3, minHeight: "25vh", ml: 1 }}>
                    <Grid container>
                      {excList.map((item, index) => {
                        return (
                          <Grid xs={2.4} align={"center"}>
                            <Grow in={true} key={index} timeout={100 * (index + 1)} onEntered={endListener}>
                              <Box>{item.name}</Box>
                            </Grow>
                          </Grid>
                        )
                      })}
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button variant='outlined' onClick={handleClose}>
            닫기
          </Button>
          {/* <ConfirmDialog */}
          {/* 	btn={ */}
          {/* 		<Button disabled={pickList.length === 0} variant='outlined'> */}
          {/* 			선발 완료 및 저장 */}
          {/* 		</Button> */}
          {/* 	} */}
          {/* 	title={"학생 선발"} */}
          {/* 	content={"해당 강좌의 학생을 선발하고, 수강 등록 단계로 넘어 가게 됩니다."} */}
          {/* 	bc={"primary"} */}
          {/* 	perform={() => onSubmit()} */}
          {/* /> */}
        </DialogActions>
      </Dialog>

      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default ManagerRegiPartPick
